import type { UseMutationResult } from 'react-query'
import type { UseMutateAsyncFunction } from 'react-query/types/react/types'

export type Mutate<TFunction> = TFunction & {
  _isLoading: boolean
  _isSuccess: boolean
  _isError: boolean
  _queryError: unknown
}

export function mutate<
  TData = unknown,
  TError = unknown,
  TVariables = unknown,
  TContext = unknown,
>(
  mutation: UseMutationResult<TData, TError, TVariables, TContext>,
): Mutate<UseMutateAsyncFunction<TData, TError, TVariables, TContext>> {
  return Object.assign(mutation.mutateAsync.bind(mutation), {
    _isLoading: mutation.isLoading,
    _isSuccess: mutation.isSuccess,
    _isError: mutation.isError,
    _queryError: mutation.error,
  })
}
